module.exports = __webpack_public_path__ + "img/Dapta-Brandmark-RGB.b5e1f792.png";